import { useEffect, useState } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f43d1e8af7e4fc2de0365c091faa2b12.jpg"
          alt="Monceau Fleurs"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl mx-auto w-full">
        <h1 className="text-4xl sm:text-5xl md:text-8xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          法式花藝美學
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-white/95 mb-3 sm:mb-4 font-light leading-relaxed">
          來自巴黎的優雅花藝品牌
        </p>
        <p className="text-sm sm:text-base md:text-lg text-white/90 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-4">
          Monceau Fleurs 將法國花藝的精緻與優雅帶到台灣，每一束花都是藝術品，每一個設計都訴說著獨特的故事
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center items-center px-4">
          <a
            href="#products"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-white text-[#2C2C2C] text-sm sm:text-base font-semibold rounded-full hover:bg-[#F5F5F5] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            探索花藝作品
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-transparent text-white text-sm sm:text-base font-semibold rounded-full border-2 border-white hover:bg-white hover:text-[#2C2C2C] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            聯繫我們
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl sm:text-4xl text-white/80"></i>
      </div>
    </section>
  );
}
